export const CALCULATOR_STRING = 'calculator'
export const CALCULATOR_ROOT_STRING = 'calculator-root'
export const DEFAULT_INPUT_VALUE_FOR_CALCULATOR = 1
export const FOOTPRINT_COMPENSATION_CALCULATOR_STRING = 'footprint'
export const SINGLE_COMPENSATION_CALCULATOR_STRING = 'single'
